module.exports = __webpack_public_path__ + "assets/img/pop-icon-3.a3a38853.png";